import { IRole } from '@boma/client-shared';

export interface IAdministrator {
  id: string;
  firstName: string;
  surname: any;
  roles: IRole[];
}
